import config from 'Cloud/config';
import { extInfo } from 'lib/extInfo';
import { stringify } from 'qs';
import { SearchOptionType } from 'reactApp/sections/AlbumsPage/SelectFromCloudPopup/components/SelectFromCloudSearch/SelectFromCloudSearch.types';
import { ESearchOptionSource, ESearchOptionType } from 'reactApp/ui/WebSearch/WebSearch.data';

export const SEARCH_PER_PAGE_LIMIT = 500;

export const getExtsBySearchType = (searchType: string, isAlbumsSearch: boolean) => {
    if (searchType === SearchOptionType.media && isAlbumsSearch) {
        return extInfo.getExtsForAlbums().join(',');
    }

    if (isAlbumsSearch) {
        return extInfo.getExtsForAlbumsByKind(searchType).join(',');
    }

    return extInfo.getExtsByKind(searchType).join(',');
};

export const getSearchQueryString = (
    query: string,
    { searchType, searchSource }: { searchType?: ESearchOptionType; searchSource?: ESearchOptionSource }
) => stringify({ query, searchType, searchSource }, { addQueryPrefix: true });

export const getUserSearchParams = () => {
    const isPaidUser = config.get('PAID_USER');
    const isProUser = config.get('IS_PRO_USER');
    return { isPaidUser, isProUser };
};
